/**
 * Schedule item types that are plain text rows: a title, an optional
 * description and a duration, edited in the feature dialog. They differ only
 * in their label and colour.
 */
export const TEXT_SCHEDULE_ITEM_TYPES = [
  "feature",
  "collect",
  "communion",
] as const;

export type TextScheduleItemType = (typeof TEXT_SCHEDULE_ITEM_TYPES)[number];

export const isTextScheduleItemType = (
  type: string | null | undefined,
): type is TextScheduleItemType =>
  (TEXT_SCHEDULE_ITEM_TYPES as readonly string[]).includes(type ?? "");

/** The locale key naming each text item type. */
export const textScheduleItemTypeLabelKey: Record<TextScheduleItemType, string> =
  {
    feature: "Feature",
    collect: "Offering",
    communion: "Communion",
  };

/**
 * Seconds a new schedule item of each type is given. New items store their
 * duration explicitly, so changing a value here never moves existing events.
 * (Rows written before durations were stored fall back to the older values
 * in Schedule.vue and ScheduleItem.vue instead.)
 */
export const DEFAULT_SCHEDULE_ITEM_DURATIONS: Record<string, number> = {
  song: 300,
  sermon: 2400,
  feature: 150,
  collect: 150,
  communion: 600,
  slides: 300,
};

export const defaultScheduleItemDuration = (
  type: string | null | undefined,
): number => DEFAULT_SCHEDULE_ITEM_DURATIONS[type ?? ""] ?? 300;

/**
 * MobilePay numbers are kept as a string of digits: a string, so a leading
 * zero survives, and digits only, so "12 34 56" and "123456" are one number.
 */
export const normalizeMobilePayNumber = (
  value: string | null | undefined,
): string => (value ?? "").replace(/\D/g, "");
